import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { FlagProvider } from '@unleash/proxy-client-react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { IntlProvider } from 'react-intl'
import { pdfjs } from 'react-pdf'
import { PdfTabReminderHost } from '~/features/pdf-tab-reminder'
import { unleashClient } from '~/shared/lib/feature-flags'
import { Toaster } from '~/shared/ui'
import { AppRouter } from './router'
import './styles/global.css'
import './styles/style.scss'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
})

export function App() {
  return (
    <IntlProvider locale="en">
      <QueryClientProvider client={queryClient}>
        <FlagProvider unleashClient={unleashClient}>
          <NuqsAdapter>
            <AppRouter />
            <Toaster />
            <PdfTabReminderHost />
          </NuqsAdapter>
        </FlagProvider>
        {/* <ReactQueryDevtools /> */}
      </QueryClientProvider>
    </IntlProvider>
  )
}
